import React from "react";
import { Block } from "jsxstyle";

export default function Loading() {
  return (
    <Block
      className="loading"
      position="absolute"
      top="0"
      right="0"
      bottom="0"
      left="0"
    />
  );
}
